module.exports = __webpack_public_path__ + "img/pic_earncoins_coins@3x.c6f52dc2.png";